export const getApEmbedTokenUrl = () => '/business/ap_embed_token';
